import React from "react";
import MapModal from './modals/MapModal';

class Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      modalRef: document.body

    };

    this.openMapModal = this.openMapModal.bind(this);
    this.closeMapModal = this.closeMapModal.bind(this);
    this.setModalRef = this.setModalRef.bind(this);
    this.goToLocation = this.goToLocation.bind(this);
  }

  openMapModal() {
    this.setState({ open: true });
  }

  closeMapModal() {

    this.setState({ open: false });
    this.props.history.push('/');
  }

  openNotifyModal() {
    this.setState({ open: true });
  }

  closeNotifyModal() {

    this.setState({ open: false });
  }

  setModalRef(context) {
    this.setState({
      // modalRef : context
    });
  }

  componentDidMount() {
    if (this.props.openLocation) {
      this.openMapModal();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.openLocation !== this.props.openLocation) {
      if (this.props.openLocation) {
        this.openMapModal();
      }
      else {
        this.closeMapModal();
      }
    }
  }

  goToLocation() {
    this.props.history.push('/locations');
  }

  render() {
    const { open, modalRef } = this.state;
    return (
      <section className="map-availability ui grid mx-0 my-0">
        <div className="ui container">
          <div className="ui grid two column">
            <div className="sixteen wide tablet seven wide computer column sm-text-center">
              <h3 className="title">Our Availability</h3>
              <div className="display-1">
                Serving condos in Toronto, Ottawa
              and Metro Vancouver
              </div>
              <p className="desc text-grey3">
                FibreStream is able to offer the best internet value and the fastest speeds by installing its own private fibre network in your building.
              </p>
            </div>
            <div className="sixteen wide tablet seven wide computer column sm-text-center right floated">
              <div className="ui middle aligned center grid map-image">
                <div className="map--custom row cursor-pointer" onClick={this.goToLocation}>
                  {/* <div className="map__image"> */}
                  <div className="column ui grid centered aligned centered">
                    <button className="ui button black btn--view-map js-view-map">
                      View map
                      </button>
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MapModal open={open} closeMapModal={this.closeMapModal} modalRef={modalRef} />
        <div style={{ backgroundColor: '#fff', zIndex: 9 }} ref={this.setModalRef}></div>
      </section>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/home/map/Map.js